import React from 'react'
import { func } from 'prop-types'
import Modal from '../Modal/Modal'
import IcoChat from '../icons/IcoChat'
import { BtnGhost, BtnPrimary } from '../ui/buttons'
import { INSTAGRAM_DM_PEDRO, INSTAGRAM_PERFIL_PEDRO } from '../../data/links'
import { theme } from '../../styles'
import { Callout, CalloutTexto } from './cancel-flow-styles'


function urlInstagram() {
  const isMobile = ( /iPhone|iPad|iPod|Android/iu ).test( navigator.userAgent )
  return isMobile ? INSTAGRAM_DM_PEDRO : INSTAGRAM_PERFIL_PEDRO
}

export default function ConversaInstagram( { onClose, onBack } ) {
  const falarComPedro = () => {
    const abaNova = window.open( urlInstagram(), '_blank' )
    if ( abaNova ) {
      abaNova.opener = null
    }
  }

  const footer = (
    <>
      <BtnGhost
        onClick={ onBack }
        type="button"
      >Voltar
      </BtnGhost>
      <BtnPrimary
        onClick={ falarComPedro }
        type="button"
      >Quero falar com o Pedro no Instagram
      </BtnPrimary>
    </>
  )

  return (
    <Modal
      eyebrow="Cancelar renovação"
      footer={ footer }
      onClose={ onClose }
      steps={{ 'cur': 1 }}
    >
      <Callout>
        <IcoChat
          height="20"
          style={{ 'color': theme.cores.accent, 'flex': 'none' }}
          width="20"
        />
        <CalloutTexto>
          <p>
            Se você está em dúvida sobre continuar no clube, o Pedro quer te ouvir diretamente.
            Mande um &quot;oi&quot; para ele no Instagram e vamos conversar sobre a sua experiência.
          </p>
          <p>Envie suas dúvidas via DM e ele te responderá pessoalmente assim que puder!</p>
        </CalloutTexto>
      </Callout>
      <p>
        <b>Importante:</b> sua assinatura continuará ativa. Essa etapa não solicita o cancelamento.
        <br />
        Se, depois da conversa, você decidir cancelar, é só voltar à Área do Associado e iniciar
        novamente o processo de cancelamento.
      </p>
    </Modal>
  )
}

ConversaInstagram.propTypes = {
  'onClose': func.isRequired,
  'onBack': func.isRequired
}
